// jshint module: true

import throttle from 'lodash/throttle';
import supportsPassiveListener from './../../assets/scripts/modules/supports-passive-listener';
import findParentByClassName from './../../assets/scripts/modules/find-parent-by-classname';

const component = 'picture';
const selector = `.${component}`;
const scrollOffset = window.innerHeight * 3;
const fadeIn = true;

let elements = [];

function loadImage(element) {
  const picture = element.querySelector('.picture__picture');

  if (!picture) {
    return;
  }

  if (picture.innerHTML.indexOf('data-srcset') > -1) {
    // Replace data-srcset, IE11 doesn't like it if we touch <source> elements in any way.
    picture.innerHTML = picture.innerHTML.replace(/data-srcset/g, 'srcset');

    if (window.picturefill) {
      window.picturefill();
    }
  }

  const img = picture.querySelector('img');

  if (!img) {
    return;
  }

  let src = img.getAttribute('data-src');

  if (!src || img.getAttribute('data-loading')) {
    return;
  }

  if (src[0] === '\'' || src[0] === '"') {
    src = src.slice(1, -1);
  }

  img.setAttribute('data-loading', true);

  let image = new Image();

  image.onload = function() {

    img.removeAttribute('data-src');
    img.setAttribute('src', src);
    image = null;

    img.removeAttribute('data-loading');

    // Show on next paint
    window.requestAnimationFrame(() => {

      if (fadeIn) {
        element.classList.remove('is-hidden');
      }

      if (window.picturefill) {
        window.picturefill();
      }

    });

  };

  image.src = src;

}

function windowScrollHandler() {

  const filteredElements = [...elements].filter((element) => {
    //const notProcessed = !element.getAttribute('data-src');

    //if (notProcessed) {
    //  return true;
    //}

    const page = findParentByClassName(element, 'page');

    if (page && !page.classList.contains('is-target') && !page.classList.contains('will-be-target')) {
      return false;
    }

    const rect = element.getBoundingClientRect();
    const topInView = rect.top > -scrollOffset && rect.top < (window.innerHeight + scrollOffset);
    const bottomInView = rect.bottom + scrollOffset < window.innerHeight;

    return topInView || bottomInView;
  });

  for (const element of filteredElements) {
    loadImage(element);
  }

}

function init() {

  elements = document.querySelectorAll(selector);

  if (!elements.length) {
    return;
  }

  for (const element of elements) {
    if (fadeIn) {
      element.classList.add('is-hidden');
    }
  }

  window.addEventListener('scroll', throttle(windowScrollHandler, 250, { trailing: true }), supportsPassiveListener() ? { passive: true } : false);
  window.addEventListener('resize', throttle(windowScrollHandler, 250, { trailing: true }));
  window.addEventListener('page-change', windowScrollHandler, supportsPassiveListener() ? { passive: true } : false)

  //windowScrollHandler.call();

}

window.addEventListener('init-load', init);
window.addEventListener(`reinit-${component}`, init);



// WEBPACK FOOTER //
// ./website/components/picture/picture.js